import { Stack, Typography } from '@mui/material';
import WarningTriangleIcon from '@treyd-io/treyd-ui/icons/WarningTriangleIcon';

interface Props {
  error: string;
}
export const BankIdErrorComponent = (props: Props) => {
  const { error } = props;
  return (
    <Stack gap={3} alignItems="center" textAlign="center">
      <WarningTriangleIcon
        color="error"
        width={64}
        height={64}
        sx={{ fontSize: 64 }}
      />
      <Typography variant="body1">{error}</Typography>
    </Stack>
  );
};
